import api from "@/api";
import { ApiCatalog } from "@/api/catalogs/ApiCatalog";
import { RawLangstonContentResponse } from "@/types/models/Content.interface";
import type { NextPageContext } from "next";

/**
 * Returns TanStack Query options for fetching a bundle's content document.
 * Accepts an optional `ctx` for server-side use (forwards auth cookies).
 * Intended to be passed directly to `useQuery` on the client and
 * `prefetchQuery` in `getServerSideProps`.
 */
export const bundleContentQuery = (
  contentId: string,
  ctx?: NextPageContext,
) => ({
  queryKey: [ApiCatalog.singleContentDocument.key, contentId] as const,
  queryFn: () =>
    api({ ...(ctx && { ctx }) }).get(
      ApiCatalog.singleContentDocument.endpoint,
      {
        urlReplacers: [{ id: contentId }],
      },
    ) as Promise<RawLangstonContentResponse>,
  enabled: !!contentId,
});
